module.exports = __webpack_public_path__ + "static/media/pan_sample_right.7e3f55ab.svg";